import React from 'react';
export function Footer() {
  return <footer className="py-8 bg-navy-950 border-t border-white/5 text-center px-4" data-id="element-74" data-mp="32wd2cf6gdjt0">
      <p className="text-slate-500 text-sm" data-id="element-75" data-mp="3gg11ma61ua0t">
        © {new Date().getFullYear()} Secretos de Promoción. Todos los derechos
        reservados.
      </p>
    </footer>;
}